import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  SystemComponentViewModel,
  UpdateInventoryCost,
} from "../../inventory-models";
import { InventoryService } from "../../inventory-service.service";
import { LoadingService } from "../../../../../../src/app/shared/services/loading.service";
import { NotificationsService } from "angular2-notifications";

@Component({
  selector: "app-cost-edit-popup",
  templateUrl: "./cost-edit-popup.component.html",
  styleUrls: ["./cost-edit-popup.component.scss"],
})
export class CostEditPopupComponent implements OnInit {
  CostEditPopupComponent: SystemComponentViewModel;
  constructor(
    public dialogRef: MatDialogRef<CostEditPopupComponent>,
    private inventoryService: InventoryService,
    private loadingService: LoadingService,
    private notification: NotificationsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
  saving: boolean = false;
  PartCost: number;
  LaborCost: number;
  MiscCost: number;
  inititalCost: number;
  screenId: number;
  UpdateInventoryCost: UpdateInventoryCost;
  ngOnInit(): void {
    this.CostEditPopupComponent = this.data.component;
    this.PartCost = this.CostEditPopupComponent.TotalCost;
    this.LaborCost = this.CostEditPopupComponent.LabourCost;
    this.MiscCost = this.CostEditPopupComponent.MiscCost;
    this.inititalCost = this.CostEditPopupComponent.InititalCost;
    this.screenId = this.data.screenId;
  }
  onNoClickPopup() {
    this.dialogRef.close();
  }

  UpdateCost() {
    this.saving = true;
    this.UpdateInventoryCost = new UpdateInventoryCost();
    this.UpdateInventoryCost.EqunitId = this.CostEditPopupComponent.EqunitId;
    this.UpdateInventoryCost.PartCost = this.inititalCost;
    this.UpdateInventoryCost.LabourCost = this.LaborCost;
    this.UpdateInventoryCost.MiscCost = this.MiscCost;
    this.UpdateInventoryCost.ScreenId = this.screenId;
    this.inventoryService
      .updateComponentCost(this.UpdateInventoryCost)
      .subscribe((r) => {
        if (r) {
          this.notification.success("Updated Successfully.");
          this.dialogRef.close(true);
        }
        this.saving = false;
      });
  }
}
